import { track_ga } from '@/pages/firebase'

const page = { page: 'pay-result' }
// order_code_copy	复制券码	点击
export const orderCodeCopy = (params = {}) => {
  track_ga('order_code_copy', { ...page, ...params })
}
// order_code_tip	code兑换tip	点击
export const orderCodeTip = (params = {}) => {
  track_ga('order_code_tip', { ...page, ...params })
}
// order_retry	重新下单	点击
export const orderRetry = (params = {}) => {
  track_ga('order_retry', { ...page, ...params })
}
// order_more	再来一单	点击
export const orderMore = (params = {}) => {
  track_ga('order_more', { ...page, ...params })
}
// order_coupon_check	查看优惠券点击	点击  todo...
export const orderCouponCheck = (params = {}) => {
  track_ga('order_coupon_check', { ...page, ...params })
}
// banner	运营位曝光 每展示一个banner曝光一次
export async function orderBannerShow(params = {}) {
  track_ga('order_banner_show', { ...page, ...params })
}
// banner	运营位点击	点击
export const orderBannerClick = (params = {}) => {
  track_ga('order_banner_click', { ...page, ...params })
}
// order_tomidas	点击跳转米大师	点击
export const orderTomidas = (params = {}) => {
  track_ga('order_tomidas', { ...page, ...params })
}
// 手动聚焦输入框，开始输入
export const page_input_manual = (params = {}) => {
  track_ga('page_input_manual', { ...page, ...params })
}
// 自动填充uid的情况下，访问页面时上报
export const page_input_auto = (params = {}) => {
  track_ga('page_input_auto', { ...page, ...params })
}
// uid验证成功（仅手动触发）
export const page_input_success = (params = {}) => {
  track_ga('page_input_success', { ...page, ...params })
}
// uid验证失败（仅手动触发）
export const page_input_fail = (params = {}) => {
  track_ga('page_input_fail', { ...page, ...params })
}
